import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Icon } from "@iconify/react";

const Features = () => {
    const features = [
        {
            id: 1,
            featureIcon: "uim-object-ungroup",
            featureName: "Smart Job Filters"
        },
        {
            id: 2,
            featureIcon: "uim-telegram-alt",
            featureName: "Resume Builder"
        },
        {
            id: 3,
            featureIcon: "uim-lock-access",
            featureName: "Real-Time Alerts"
        },
        {
            id: 4,
            featureIcon: "uim-user-md",
            featureName: "Verified Listings"
        },
        {
            id: 5,
            featureIcon: "uim-airplay",
            featureName: "Quick Apply Option"
        },
        {
            id: 6,
            featureIcon: "uim-rocket",
            featureName: "Easy Profile Setup"
        },
        {
            id: 7,
            featureIcon: "uim-history",
            featureName: "Secure Messaging"
        },
        {
            id: 8,
            featureIcon: "uim-bookmark",
            featureName: "Employer Dashboard"
        },
        {
            id: 9,
            featureIcon: "uim-graph-bar",
            featureName: "Instant Notifications"
        }
    ];
    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={7}>
                            <div className="section-title text-center mb-5">
                                <h3 className="title mb-4">Key Features</h3>
                                <p className="para-desc text-muted mx-auto">
                                    Discover powerful tools designed to simplify your job search and hiring process. Our platform ensures a smooth, efficient, and tailored experience for both candidates and employers.
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {features.map((featuresDetails, key) => (
                            <Col lg={4} md={6} className="mt-4 pt-2" key={key}>
                                <div className="about-feature p-3 d-flex align-items-center rounded-3">
                                    <div className="featrue-icon flex-shrink-0">
                                        <Icon
                                            icon={featuresDetails.featureIcon}
                                            className="text-primary"
                                        />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-18 mb-0">
                                            {featuresDetails.featureName}
                                        </h6>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Features;
